module.exports = __webpack_public_path__ + "static/sport/h5out3.44a8f31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/h5out3.png
// module id = GeYP
// module chunks = 0